import { render, staticRenderFns } from "./OrderConfliction.vue?vue&type=template&id=0e70ced4"
import script from "./OrderConfliction.vue?vue&type=script&lang=js"
export * from "./OrderConfliction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports